export function enhancePasswords(root = document) {
  root.querySelectorAll('input[type="password"]').forEach(input => {
    if (input.closest('.sf-password-control')) return;
    const wrap = document.createElement('div'); wrap.className = 'sf-password-control';
    input.before(wrap); wrap.append(input);
    const toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'sf-password-toggle';
    toggle.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/><path class="sf-eye-slash" d="m3 3 18 18"/></svg>';
    const reset = () => { input.type = 'password'; toggle.setAttribute('aria-label','Show password'); toggle.setAttribute('aria-pressed','false'); };
    reset(); if(input.id) toggle.setAttribute('aria-controls',input.id);
    toggle.addEventListener('click',()=>{ const show=input.type==='password';input.type=show?'text':'password';toggle.setAttribute('aria-label',show?'Hide password':'Show password');toggle.setAttribute('aria-pressed',String(show)); });
    input.form?.addEventListener('submit',reset);
    input.form?.addEventListener('reset',reset);
    wrap.append(toggle);
  });
}
enhancePasswords();
document.addEventListener('shopify:section:load',event=>enhancePasswords(event.target));
